import { render, staticRenderFns } from "./GradeFeeList.vue?vue&type=template&id=670123e9"
import script from "../../controllers/grade_fee/grade-fee-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/grade_fee/grade-fee-list.js?vue&type=script&lang=js&external"
import style0 from "./GradeFeeList.vue?vue&type=style&index=0&id=670123e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports